module.exports = __webpack_public_path__ + "ab916c2c45396a9d156d7b3772f265e0.png";